import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';

/**
 * Footer of a KOST import wizard step, per the buttons styleguide: "Weiter" is
 * the step's one primary action, "Zurück" a quiet text button that is never
 * disabled. A disabled "Weiter" names what is missing in its tooltip. The
 * transfer step has no footer: the upload starts there and cannot be undone.
 */
@Component({
  selector: 'kost-data-import-wizard-nav',
  template: `
    <div
      class="flex pt-4"
      [class.justify-between]="back()"
      [class.justify-end]="!back()"
    >
      @if (back()) {
        <p-button
          label="Zurück"
          severity="secondary"
          [text]="true"
          [pt]="{ root: { 'data-test': 'kost-wizard-previous' } }"
          (onClick)="previous.emit()"
        />
      }
      <p-button
        label="Weiter"
        severity="primary"
        [disabled]="!nextAllowed()"
        [pTooltip]="nextDisabledReason()"
        [tooltipDisabled]="nextAllowed()"
        tooltipPosition="top"
        [pt]="{ root: { 'data-test': 'kost-wizard-next' } }"
        (onClick)="next.emit()"
      />
    </div>
  `,
  imports: [Button, Tooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KostDataImportWizardNavComponent {
  /** `false` on the first step, which has nothing to go back to. */
  public readonly back = input(true);
  public readonly nextAllowed = input(false);
  /** What the user still has to do before "Weiter" is enabled. */
  public readonly nextDisabledReason = input.required<string>();

  public readonly previous = output();
  public readonly next = output();
}
